import { ISearchElementStyle } from './searchPageConfig';

// Admin-editor mirror of the shopper cart-page config
// (ac-storefront-web: Components/Helpers/cartPageConfig.ts). Persisted as a single JSON string
// on IStorefrontSettings.cartPageConfig. Each section is a bag of CSS props (ISearchElementStyle)
// applied to a bounding component of the cart page. Absent config = zero inline styles (strictly additive).
export interface ICartPageConfig {
    container?: ISearchElementStyle;
    title?: ISearchElementStyle;
    itemRow?: ISearchElementStyle;
    bundleRow?: ISearchElementStyle;
    // The per-line quantity stepper input (desktop table + mobile card share this).
    quantityInput?: ISearchElementStyle;
    // The container wrapping all the line-item rows (desktop table + mobile list).
    rowsContainer?: ISearchElementStyle;
    summaryBox?: ISearchElementStyle;
    summaryHeading?: ISearchElementStyle;
    checkoutButton?: ISearchElementStyle;
    secondaryButton?: ISearchElementStyle;
    emptyState?: ISearchElementStyle;
    // The "Go Home" button inside the empty-cart state (defaults to Fluent primary blue).
    emptyStateButton?: ISearchElementStyle;
    // Behavior flag (not a style section): when true, the shopper's header cart icon opens the cart
    // in a right-side slide-out panel instead of navigating to the full /cart page.
    openInPanel?: boolean;
}

export const CART_PAGE_SECTIONS = [
    'container', 'title', 'itemRow', 'bundleRow', 'quantityInput', 'rowsContainer', 'summaryBox',
    'summaryHeading', 'checkoutButton', 'secondaryButton', 'emptyState', 'emptyStateButton',
] as const;

export const DEFAULT_CART_PAGE_CONFIG: ICartPageConfig = {};

export function parseCartPageConfig(raw?: string): ICartPageConfig {
    if (!raw) return { ...DEFAULT_CART_PAGE_CONFIG };
    try {
        return { ...DEFAULT_CART_PAGE_CONFIG, ...(JSON.parse(raw) as ICartPageConfig) };
    } catch {
        return { ...DEFAULT_CART_PAGE_CONFIG };
    }
}

export function serializeCartPageConfig(config: ICartPageConfig): string {
    return JSON.stringify(config);
}
